
import Animations from "./animations";

const Tabs = (target) => {
  const tabHeaders = target.querySelectorAll(".tab__header");
  const tabContents = target.querySelectorAll(".tab__content");

  const method = {
    init: () => {
      if (tabHeaders.length > 0 && tabContents.length > 0) {
        tabHeaders.forEach((t: HTMLElement) => {
          t.addEventListener("click", method.onClick);
        });
      }
    },
    onClick: (e) => {
      e.preventDefault();
      const isCurrentOpen = e.target.classList.contains("tab__header--selected");
      const currentID = e.target.getAttribute("data-tab");
      const tabUrl = e.target.getAttribute("data-tabUrl");

      if (tabUrl) {
        window.history.pushState({}, "", tabUrl);
      }

      if (!isCurrentOpen) {
        method.closeAll();
        method.doOpen(currentID);
      }
    },
    doOpen: (id: string) => {
      const newTabHeader = target.querySelector(`#tab-${id}-header`);
      const newTabContent = target.querySelector(`#tab-${id}-content`);
      newTabHeader.setAttribute("aria-selected", "true");

      newTabHeader.classList.add(`tab__header--selected`);
      newTabContent.classList.add(`tab__content--selected`);

      Animations.animateItemsList(newTabContent, ".card");
    },
    closeAll: () => {
      tabHeaders.forEach((t: HTMLElement) => {
        t.classList.remove("tab__header--selected");
        t.setAttribute("aria-selected", "false");
      });

      tabContents.forEach((t: HTMLElement) => {
        t.classList.remove("tab__content--selected");
      });
    },
  };

  method.init();
};

export default Tabs;
